<div [ngClass]="isCombo ? 'option-row__epcot-combo-header' : 'option-row__header'">
    <div [ngClass]="!isEpcotEnabled && isByb ? 'inline-title-container' : 'title-container'">
        <div [ngClass]="isEpcotEnabled ? (isCombo ? 'option-row__epcot-combo-header-line-0' : '') : 'bet-builder-icon'">{{ headerTitle }}</div>
        @if (isEpcotEnabled) {
            <i class="info-icon theme-info" (click)="toggleBetbuilderInfoMessage($event)"></i>
        }
        @if (hasWarning) {
            <i class="theme-warning"></i>
        }
    </div>
    @if (showBetbuilderInfoMessage) {
        <bs-digital-betbuilder-info-message (close)="closeBetbuilderInfoMessage()"></bs-digital-betbuilder-info-message>
    }
    <div [ngClass]="isEpcotEnabled ? 'betslip-digital-pick__line-1' : 'option'" [msAutomation]="'betslip-pick-option-name'">
        <span>{{ pick?.eventName?.name }}</span>
        @if (isEpcotEnabled || !isByb) {
            <div class="eventDate">
                <span class="date">{{ date }}</span>
            </div>
        }
    </div>
</div>

<div class="option-row">
    <div class="option" [msAutomation]="'betslip-pick-option-name'">
        @for (selection of selections; track selection) {
            <bs-betslip-betbuilder-selection
                [pick]="pick"
                [selection]="selection"
                [showRemoveButton]="isRemoveButtonVisible"
                (selectionRemove)="removeBetBuilderSelection($event)">
            </bs-betslip-betbuilder-selection>
        }
    </div>
</div>
